import { isMobile } from "../common/utils";

import Wishlist from "../common/wishlist";
const wishlist = Wishlist();

import Swiper from "swiper";
let __swiper = null;

const initializeProduct = (section) => {
  if (isMobile()) {
    initializeSwiper();
    initializeTabButtons();
  } else {
    initializeImageZoom();
  }
  initializePrice();
  initializeVariantPrice();
  initializeWishList();
  initializeBottomBar();
  initializeWrapping();
  initializeMoreButton(section);
};

/*
 * Zoom (PC)
 */

const initializeImageZoom = () => {
  document.querySelectorAll(".fs-image-container").forEach((container) => {
    const img = container.querySelector("img");

    const updateImage = (e) => {
      const scale = 3.0;
      const boost = 1.3333;
      const rect = container.getBoundingClientRect();
      const posX = Math.min(0.5, Math.max(-0.5, (e.offsetX / rect.width - 0.5) * boost));
      const posY = Math.min(0.5, Math.max(-0.5, (e.offsetY / rect.height - 0.5) * boost));
      const offsetX = 0 - rect.width * (scale - 1.0) * posX;
      const offsetY = 0 - rect.height * (scale - 1.0) * posY;
      img.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
    };

    const toggleZoom = (e) => {
      if (container.classList.contains("zoom")) {
        container.removeEventListener("mousemove", onMouseMove);
        container.removeEventListener("mouseleave", onMouseLeave);
        container.classList.remove("zoom");
        img.style.transform = `translate(0, 0) scale(1.0)`;
      } else {
        container.addEventListener("mousemove", onMouseMove);
        container.addEventListener("mouseleave", onMouseLeave);
        container.classList.add("zoom");
        updateImage(e);
      }
    };

    const onMouseMove = (e) => {
      updateImage(e);
    };

    const onMouseLeave = (e) => {
      toggleZoom(e);
    };

    container.addEventListener("click", (e) => {
      toggleZoom(e);
    });
  });
};

/*
 * Swiper (Mobile)
 */

const initializeSwiper = () => {
  const container = document.getElementById("product-2023-images-container");
  const wrapper = container.children[0];
  container.classList.add("swiper");
  wrapper.classList.add("swiper-wrapper");
  for (let i = 0; i < wrapper.children.length; i++) {
    wrapper.children[i].classList.add("swiper-slide");
  }
  __swiper = new Swiper("#product-2023-images-container", {
    loop: true,
  });

  __swiper.on("slideChange", slideChanged);

  const prev = document.getElementById("product-2023-images-prev");
  prev.addEventListener("click", prevClicked);

  const next = document.getElementById("product-2023-images-next");
  next.addEventListener("click", nextClicked);

  const thumbs = document.querySelectorAll(
    ".product-2023-images .fs-thumbs-container .fs-thumbs .fs-thumbs-inner .fs-thumb",
  );
  thumbs.forEach((el) => el.addEventListener("click", thumbClicked));

  slideChanged();
};

const slideChanged = () => {
  document.getElementById("product-2023-images-index").textContent = __swiper.realIndex + 1;
};

const prevClicked = () => {
  __swiper.slidePrev();
};

const nextClicked = () => {
  __swiper.slideNext();
};

const thumbClicked = (e) => {
  __swiper.slideTo(parseInt(e.target.dataset.index) + 1);
};

/*
 * Tab Buttons (Mobile)
 */

let __headerBottom = 0;
let __tabs = null;
let __tabButtons = null;

const initializeTabButtons = () => {
  const headerBar = document.querySelector("#shopify-section-header .fs-header .fs-content");
  const headerBarRect = headerBar.getBoundingClientRect();
  __headerBottom = headerBarRect.bottom; // mmm...
  __tabs = document.querySelector("#fs-tabs");
  __tabButtons = document.querySelector("#fs-tab-buttons");
  window.addEventListener("scroll", handleScroll);
  document.querySelectorAll(".fs-tab-button").forEach((tabButton) => {
    tabButton.addEventListener("click", tabButtonClicked);
  });
};

const handleScroll = (e) => {
  const headerBar = document.querySelector("#shopify-section-header .fs-header .fs-content");
  const headerBarRect = headerBar.getBoundingClientRect();
  __headerBottom = headerBarRect.bottom;

  const tabsRect = __tabs.getBoundingClientRect();
  const tabButtonsRect = __tabButtons.getBoundingClientRect();

  if (tabsRect.top - __headerBottom < 0 && 0 <= tabsRect.bottom - tabButtonsRect.height - __headerBottom) {
    // FIXED
    const h = Math.max(44, tabsRect.top - __headerBottom + 60);
    __tabButtons.classList.remove("fs-top");
    __tabButtons.style.position = "fixed";
    __tabButtons.style.top = `${__headerBottom}px`;
    __tabButtons.style.height = `${h}px`;
  } else if (0 < tabsRect.y - __headerBottom) {
    // TOP
    __tabButtons.classList.add("fs-top");
    __tabButtons.style.position = "absolute";
    __tabButtons.style.top = "0";
    __tabButtons.style.height = "60px";
  } else {
    // BOTTOM
    const top = tabsRect.height - tabButtonsRect.height;
    __tabButtons.classList.remove("fs-top");
    __tabButtons.style.position = "absolute";
    __tabButtons.style.top = `${top}px`;
  }
};

const tabButtonClicked = (e) => {
  const tabIndex = parseInt(e.target.dataset.index);

  document.querySelectorAll(".fs-tab-button").forEach((tabButton) => {
    if (parseInt(tabButton.dataset.index) == tabIndex) {
      tabButton.classList.add("selected");
    } else {
      tabButton.classList.remove("selected");
    }
  });
  document.querySelectorAll(".fs-tab").forEach((tab) => {
    if (parseInt(tab.dataset.index) == tabIndex) {
      tab.classList.add("selected");
    } else {
      tab.classList.remove("selected");
    }
  });

  let top = __tabs.offsetTop - __headerBottom + 16;
  window.scrollTo({ top: top, behavior: "smooth" });
};

/*
 * Price
 */

const initializePrice = () => {
  const compareAtPriceSpan = document.querySelector("#fs-compare-at-price");
  if (!compareAtPriceSpan) {
    return;
  }
  const compareAtPrice = compareAtPriceSpan.dataset.compareAtPrice;
  const price = compareAtPriceSpan.dataset.price;
  let percentage = Math.round((1.0 - parseFloat(price) / parseFloat(compareAtPrice)) * 100);
  document.querySelectorAll(".fs-discount-percentage").forEach((el) => (el.textContent = `${percentage}% Off`));
};

/*
 * Variant price
 */

const initializeVariantPrice = () => {
  const product = window.fstore.product;
  if (!product) {
    return;
  }
  if (product.options.length != 2) {
    return;
  }
  let colorOptionIndex = -1;
  let sizeOptionIndex = -1;
  for (let i = 0; i < product.options.length; i++) {
    let downcasedOption = product.options[i].toLowerCase();
    if (downcasedOption == "カラー" || downcasedOption == "color" || downcasedOption == "色") {
      colorOptionIndex = i;
    } else if (downcasedOption == "サイズ" || downcasedOption == "size") {
      sizeOptionIndex = i;
    }
  }
  if (colorOptionIndex < 0 || sizeOptionIndex < 0) {
    return;
  }

  let error = false;
  let colorPrices = {};
  let lastPrice = 0;
  let hasRange = false;
  product.variants.forEach((variant) => {
    const color = variant[`option${colorOptionIndex + 1}`];
    if (lastPrice == 0) {
      lastPrice = variant.price;
    } else if (lastPrice != variant.price) {
      hasRange = true;
    }
    if (!colorPrices[color]) {
      colorPrices[color] = variant.price;
    } else if (colorPrices[color] != variant.price) {
      error = true;
    }
  });
  if (error || !hasRange) {
    return;
  }

  document.querySelectorAll(".fs-color-variant-price").forEach((el) => {
    const price = colorPrices[el.dataset.color] / 100.0;
    if (price) {
      el.innerHTML = `&yen;${new Intl.NumberFormat("ja-JP").format(price)}`;
    }
  });
};

/*
 * Wishlist
 */

const initializeWishList = () => {
  document.querySelectorAll(".fs-wishlist-variant-button").forEach((button) => {
    button.addEventListener("click", wishListButtonClicked);
  });
};

const wishListButtonClicked = (e) => {
  const button = e.target;
  wishlist.toggleWishlistWithVariantId(
    parseInt(button.dataset.productId),
    parseInt(button.dataset.variantId),
    button.dataset.productHandle,
  );
};

/*
 * BottomBar
 */

const initializeBottomBar = () => {
  const footer = document.querySelector("#shopify-section-footer");
  const bottomBar = document.querySelector("#product-2023-bottom-bar");

  const updateBottomBar = () => {
    const footerRect = footer.getBoundingClientRect();
    const bottomBarRect = bottomBar.getBoundingClientRect();
    bottomBar.classList.toggle("show", window.innerHeight < footerRect.top);
  };

  window.addEventListener("load", updateBottomBar);
  window.addEventListener("scroll", updateBottomBar);

  const sheet = document.querySelector("#product-2023-bottom-sheet");
  const header = document.querySelector("#fs-bottom-sheet-header");

  const cartButton = bottomBar.querySelector(".fs-cart-button");
  cartButton.addEventListener("click", (e) => {
    sheet.classList.add("show");
    header.classList.add("show");
  });

  const wishlistButton = bottomBar.querySelector(".fs-wishlist-button");
  wishlistButton.addEventListener("click", wishListButtonClicked);

  document.querySelector("#fs-bottom-sheet-close-button").addEventListener("click", () => {
    sheet.classList.remove("show");
    header.classList.remove("show");
  });
};

/*
 * Wrapping
 */

const initializeWrapping = () => {
  document.querySelectorAll(".product-2023-content-guide").forEach((contentGuide) => {
    const button = contentGuide.querySelector(".fs-wrapping-popup-button");
    if (button) {
      const wrappingPopup = contentGuide.querySelector(".fs-wrapping-popup-dialog");
      button.addEventListener("click", () => showWrappingPopup(wrappingPopup));
    }
  });
};

const showWrappingPopup = (wrappingPopup) => {
  const popup = wrappingPopup;
  popup.classList.add("show");
  const backdrop = popup.querySelector(".fs-popup-backdrop");
  const closeButton = popup.querySelector(".fs-close-button");
  backdrop.addEventListener("click", () => {
    popup.classList.remove("show");
    backdrop.removeEventListener("click");
    closeButton.removeEventListener("click");
  });
  closeButton.addEventListener("click", () => {
    popup.classList.remove("show");
    backdrop.removeEventListener("click");
    closeButton.removeEventListener("click");
  });
};

const initializeMoreButton = (section) => {
  const sectionEl = document.querySelector(`#shopify-section-${section.id}`);
  const el = sectionEl.querySelector("#fs-product-description-more-button");
  if (el) {
    el.addEventListener("click", () => {
      const descriptionEl = sectionEl.querySelector(".fs-product-description-text");
      descriptionEl.classList.add("show-more");
      const row = sectionEl.querySelector(".fs-more-button-row");
      row.style.display = "none";
    });
  }
};

/*
 *
 */

// document.addEventListener('DOMContentLoaded', () => {

function FV_Milstone_Tracker() {
  if (!window.Shopify || !window.Shopify.analytics || !window.Shopify.analytics.publish) {
    return;
  }

  const EVENT_PREFIX = "nn";
  const isPC = window.innerWidth >= 768;
  const pageUrl = window.location.href;

  let fvFired = false;
  const firedMilestones = new Set();

  const publish = (name, data = {}) => {
    window.Shopify.analytics.publish(`${EVENT_PREFIX}:${name}`, {
      ...data,
      page_url: pageUrl,
      device: isPC ? "PC" : "Mobile",
      timestamp: Date.now(),
    });
  };

  const fireFv = (method) => {
    if (fvFired) return;
    fvFired = true;
    publish("fv_pass", { method });
  };

  const isProductPage =
    document.body.classList.contains("template-product") || location.pathname.includes("/products/");

  if (!isProductPage) return;

  const onScroll = () => {
    if (window.scrollY > 100) {
      fireFv("scroll");
    }
  };

  window.addEventListener("scroll", onScroll, { passive: true });

  setTimeout(() => {
    fireFv("stay");
  }, 5000);

  const milestones = {
    ".product-description": "2_DeepDive",
    ".styling-snaps": "4_Inspiration",
    footer: "5_Complete",
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const label = entry.target.getAttribute("data-ms");
        if (!label) return;
        if (firedMilestones.has(label)) return;

        firedMilestones.add(label);

        publish("content_milestone", {
          label,
        });

        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.1,
    },
  );

  Object.entries(milestones).forEach(([selector, label]) => {
    const el = document.querySelector(selector);
    if (!el) return;

    el.setAttribute("data-ms", label);
    observer.observe(el);
  });
}

/*
 * Main
 */

const productMain = () => {
  if (!location.pathname.startsWith("/products/")) {
    return;
  }
  window.fstore.sections.forEach((section) => {
    if (section.sectionType == "product-2023") {
      initializeProduct(section);
    }
  });
  FV_Milstone_Tracker();
};

addEventListener("DOMContentLoaded", () => {
  productMain();
});
